module.exports = __webpack_public_path__ + "img/31.a154be22.jpg";